const IlotA_mall_1 = require('./IlotA_mall_1.webp');
const IlotA_mall_2 = require('./IlotA_mall_2.webp');
const IlotA_mall_3 = require('./IlotA_mall_3.webp');
export default [IlotA_mall_1, IlotA_mall_2, IlotA_mall_3];
